export const networkImage = "networkImage";
export const profileImage = "profileImage";
export const sendEmail = "sendEmail";
export const sendText = "sendText";
export const addAdmin = "addAdmin";
export const createSignup = "createSignup";
export const ttjKeyword = "ttjKeyword";
export const createGroup = "createGroup";
export const addMember = "createMember";
export const importMember = "importMember";

/**
 * Actions whose target buttons are visible in the FloatingToolbar on mobile.
 * These skip the "open nav" step and draw/flash directly to their button.
 *
 * Used by: useNavDrawing (targetVisibleOnMobile), useIsFlashing
 */
export const mobileToolbarActions = [sendEmail, sendText, addMember, importMember];
export const customizeHomepage = "customizeHomepage";
export const addFund = "addFund";
export const addGifts = "addGifts";
export const createCampaign = "createCampaign";
export const createProfileField = "createProfileField";
export const setupDatabase = "setupDatabase";
export const enableContactUs = "enableContactUs";
export const sendWelcomeEmail = "sendWelcomeEmail";
export const createReport = "createReport";
export const runDonorSummaries = "runDonorSummaries";
export const startRESignup = "startRESignup";
export const startRESetup = "startRESetup";
export const reviewPrayerRequests = "reviewPrayerRequests";
export const reviewDuplicates = "reviewDuplicates";
export const video = "video";
export const fncPromo = "fncPromo";
export const archNYFncPromo = "archNYFncPromo";
export const registrationDrive = "registrationDrive";
export const missingEinNotice = "missingEinNotice";
export const missingEinAlert = "missingEinAlert";
export const missingEinCritical = "missingEinCritical";
